import { Menu, Tooltip, Tag, Badge, Icon, ConfigProvider } from 'ant-design-vue'

const COMPONENTS = [Menu, Menu.Item, Menu.SubMenu, Tooltip, Tag, Badge, Icon, ConfigProvider]

const install = (Vue) => {
  COMPONENTS.forEach((component) => {
    Vue.component(component.name, component)
  })
}

export default {
  install,
}
